import EditPripomienkaAdminPage from './EditPripomienkaAdminPage';

export default EditPripomienkaAdminPage;
